{
  "name": "landing-app",
  "version": "8.3.2",
  "scripts": {
    "install": "cp ./package.json ./src/assets",
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me --port 4201",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --watch=false --code-coverage",
    "watch": "ng test",
    "lint": "ng lint",
    "style-lint": "stylelint  \"src/**/*.scss\" --fix",
    "coverage": "browser-sync start --server ./coverage/landing-app --watch ''*.html"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.4",
    "@angular/cdk": "^21.1.4",
    "@angular/common": "^21.1.4",
    "@angular/compiler": "^21.1.4",
    "@angular/core": "^21.1.4",
    "@angular/forms": "^21.1.4",
    "@angular/material": "^21.1.4",
    "@angular/platform-browser": "^21.1.4",
    "@angular/platform-browser-dynamic": "^21.1.4",
    "@angular/router": "^21.1.4",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^21.1.4",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^21.1.4",
    "@angular/material-luxon-adapter": "^21.1.4",
    "@aws-sdk/client-cloudtrail": "^3.990.0",
    "@aws-sdk/client-lambda": "^3.990.0",
    "@aws-sdk/client-s3": "^3.990.0",
    "@sparbanken-syd/auth-backend": "^2.5.3",
    "@sparbanken-syd/bv-api": "^1.0.3",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^21.0.1",
    "@sparbanken-syd/sparbanken-syd-qr": "^21.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^21.2.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^21.1.1",
    "@sparbanken-syd/user-documents-backend": "^1.2.0",
    "@types/jasmine": "~6.0.0",
    "@types/karma-spec-reporter": "^0",
    "@types/luxon": "^3.7.1",
    "@types/node": "^24",
    "@typescript-eslint/eslint-plugin": "^8.55.0",
    "@typescript-eslint/parser": "^8.55.0",
    "angular-eslint": "^21.2.0",
    "aws-sdk-client-mock": "^4.1.0",
    "browser-sync": "^3.0.4",
    "eslint": "^9.39.2",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^62.5.5",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "jasmine-core": "~6.0.1",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "karma-spec-reporter": "^0.0.36",
    "luxon": "^3.7.2",
    "postcss": "^8.5.6",
    "postcss-scss": "^4.0.9",
    "puppeteer": "^24.37.3",
    "stylelint": "^17.3.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.55.0"
  }
}
